import $ from "jquery";
export default class CountDown {
    static mount() {
        $(function () {
            $(".ce-countdown").each(function () {
                new CountDown($(this));
            });
        });
    }
    constructor($parent) {
        this.updateClock = () => {
            const t = this.getTimeRemaining(this.expiredDate);
            this.$hour.html(t.hours.toString().padStart(2, "0"));
            this.$minute.html(t.minutes.toString().padStart(2, "0"));
            this.$second.html(t.seconds.toString().padStart(2, "0"));
            if (t.total <= 0) {
                this.$container.addClass('ce-countdown--expired');
                clearInterval(this.timeInterval);
            }
        };
        this.$container = $parent;
        this.$hour = $(".ce-countdown__clock__hour", $parent);
        this.$minute = $(".ce-countdown__clock__minute", $parent);
        this.$second = $(".ce-countdown__clock__second", $parent);
        this.expiredDate = new Date($parent.data("expirationdate"));
        /* this.expiredDate = new Date();
         this.expiredDate.setSeconds(this.expiredDate.getSeconds() + 3);*/
        this.timeInterval = setInterval(this.updateClock, 1000);
        this.updateClock();
    }
    getTimeRemaining(endTime) {
        const total = endTime.getTime() - new Date().getTime();
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor(total / (1000 * 60 * 60));
        return {
            total,
            hours,
            minutes,
            seconds,
        };
    }
}
